import { defineStore } from 'pinia';
import { useUserStore } from './user';
import { useToast } from 'vue-toastification';

export const useLikedSongsStore = defineStore('likedSongs', {
  state: () => ({
    ids: new Set(),
    loaded: false,
    loading: false,
  }),
  getters: {
    isLiked: (state) => (videoId) => state.ids.has(videoId),
  },
  actions: {
    async ensureLoaded() {
      const userStore = useUserStore();
      if (!userStore.user?.name) return;
      if (this.loaded || this.loading) return;

      this.loading = true;
      try {
        const ids = await fetch(`${process.env.VUE_APP_PROD_URL}/user/likedSongs`, {
          credentials: 'include',
        }).then((res) => res.json());
        this.ids = new Set(Array.isArray(ids) ? ids : []);
        this.loaded = true;
      } catch (err) {
        console.error('Error loading liked songs:', err);
      } finally {
        this.loading = false;
      }
    },
    async toggle(videoId) {
      const userStore = useUserStore();
      const toast = useToast();

      if (!userStore.user?.name) {
        toast.info('Sign in to like songs');
        return;
      }

      const wasLiked = this.ids.has(videoId);
      const endpoint = wasLiked ? 'unlikeSong' : 'likeSong';

      // Optimistic update - reverted on failure.
      if (wasLiked) {
        this.ids.delete(videoId);
      } else {
        this.ids.add(videoId);
      }

      try {
        const res = await fetch(`${process.env.VUE_APP_PROD_URL}/user/${endpoint}`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ songId: videoId }),
        }).then((r) => r.json());

        if (!res.success) {
          throw new Error(res.msg || 'Request failed');
        }
      } catch (err) {
        // revert optimistic update
        if (wasLiked) {
          this.ids.add(videoId);
        } else {
          this.ids.delete(videoId);
        }
        toast.error('Could not update liked songs. Please try again.');
      }
    },
  },
});
